import { useEffect } from "react";

export const CLIENT_REFRESH_EVENT = "client-app-refresh";

export function useClientRefresh(handler) {
  useEffect(() => {
    if (!handler) return undefined;
    const fn = () => {
      handler();
    };
    window.addEventListener(CLIENT_REFRESH_EVENT, fn);
    return () => window.removeEventListener(CLIENT_REFRESH_EVENT, fn);
  }, [handler]);
}

export function dispatchClientRefresh() {
  window.dispatchEvent(new CustomEvent(CLIENT_REFRESH_EVENT));
}
